import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/rpc';
import { queryKeys } from '../../api/queryKeys';

/**
 * Counter data for tab badges.
 *
 * Note: The backend doesn't have a getCounters method yet.
 * This hook will return empty counts until that's implemented.
 * For now we'll attempt the call and gracefully fall back to empty.
 */
export function useCounters() {
  return useQuery({
    queryKey: queryKeys.counters.all,
    queryFn: async () => {
      try {
        return await api.getCounters();
      } catch {
        // getCounters doesn't exist yet — return empty
        return {} as Record<string, number>;
      }
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
